import userAPI from '../../../../api/user'
import userHelper from '../../../../helper/user'

const state = {
  user: null,
  form: {},
  taxs: [],
  newtaxs: [],
  contact: null,
  contactForm: null,
  passwordForm: {
    email: null,
    isPassword: null,
    password: null,
    re_password: null
  },
  notifications: null,
  taxForm: {
    country: null,
    tax_id: null,
    org_legal_name: null,
    registration_date: null
  },
  defaultContactForm: {
    user_id: null,
    type: 'primary',
    notifications: [],
    title: 'Mr.',
    first_name: null,
    last_name: null,
    email: null,
    phone: null,
    position: null
  },
  defaultTaxForm: {
    tax_id: null,
    org_legal_name: null,
    registration_date: null
  }
}

const actions = {
  async initPartner ({commit, state, rootState}) {
    userAPI.getUser(rootState.user.user.id, ['UserPartner', 'Contacts', 'UserPartner.Countries']).then((response) => {
      commit('setInitial', response)
    })
    userAPI.getNotifications(rootState.user.user.id).then((response) => {
      commit('setNotifications', response)
    })
  },
  // async getContacts ({dispatch, commit}) {
  //   await dispatch('initPartner')
  //   // get contacts
  // },
  async savePartnerContact ({commit}) {
    userAPI.createContact(state.contactForm).then((response) => {
      commit('addPartnerContact', response)
      commit('resetPartnerContactForm')
      return response
    })
  },
  async addTaxDetails ({commit, rootState}) {
    userAPI.createTaxDetails(rootState.user.user.id, state.taxForm).then((response) => {
      commit('addPartnerTax')
      return response
    })
  },
  async removeTaxDetails ({commit}, payload) {
    userAPI.removeTaxDetails(payload.id).then((result) => {
      // commit('removePartnerContact', payload.id)
    })
  },
  async deletePartnerContact ({commit}, payload) {
    userAPI.deleteContact(payload.contact.id).then((result) => {
      commit('removePartnerContact', payload.contact.id)
    })
  },
  async updateProfile ({commit, state, rootState}) {
    let countries = []
    state.form.user_partner.ope_countries.forEach((country) => {
      countries.push({country_id: country.id, info_type: 'ope'})
    })
    state.form.user_partner.reg_countries.forEach((country) => {
      countries.push({country_id: country.id, info_type: 'reg'})
    })
    state.taxs.forEach((tax) => {
      countries.push({country_id: tax.country.id, info_type: 'tax', tax_id: tax.tax_id, org_legal_name: tax.org_legal_name, registration_date: tax.registration_date, info_id: tax.id})
    })
    state.form.user_partner.countries = countries
    userAPI.updateProfile(rootState.user.user.id, state.form.user_partner)
  },
  async updatePartner ({commit, state}, payload) {
    userAPI.updateAccount(payload.user_id, payload.data).then((response) => {
      commit('resetPartnerPasswordForm')
    })
  }
}

const mutations = {
  setInitial (state, response) {
    state.form = response

    let countries = state.form.user_partner.countries
    let opeCountries = []
    let regCountries = []
    countries.forEach((country) => {
      if (country.pivot.info_type === 'ope') {
        opeCountries.push(country)
      } else if (country.pivot.info_type === 'reg') {
        regCountries.push(country)
      } else if (country.pivot.info_type === 'tax') {
        // console.log(JSON.stringify(country.pivot))
        state.taxs.push({
          country: country,
          tax_id: country.pivot.tax_id,
          tax_benefit: (country.pivot.tax_id !== '') ? 'Yes' : 'No',
          org_legal_name: country.pivot.org_legal_name,
          registration_date: country.pivot.registration_date,
          info_type: country.pivot.info_type,
          info_id: country.pivot.id
        })
      }
      if (country.pivot.is_duplicate === '0' && (country.pivot.info_type === 'reg' || country.pivot.info_type === 'tax')) {
        state.newtaxs.push({
          country: country,
          tax_id: country.pivot.tax_id,
          tax_benefit: (country.pivot.tax_id !== '') ? 'Yes' : 'No',
          org_legal_name: country.pivot.org_legal_name,
          registration_date: country.pivot.registration_date,
          info_type: country.pivot.info_type,
          info_id: country.pivot.id
        })
      }
    })
    state.form.user_partner.ope_countries = opeCountries
    state.form.user_partner.reg_countries = regCountries
  },
  resetPartnerPasswordForm (state) {
    state.passwordForm = {
      password: null,
      confirm_password: null,
      isPassword: null,
      email: state.form.email
    }
  },
  resetPartnerImage (state) {
    state.form.user_partner.org_image = null
  },
  setPartnerRegCountries (state, countries) {
    state.form.user_partner.reg_countries = countries
  },
  setPartnerOpeCountries (state, countries) {
    state.form.user_partner.ope_countries = countries
  },
  updateContactNotifications (state, context) {
    let isExist = state.contactForm.notifications.filter(n => n === context.value).length
    if (!isExist) {
      state.contactForm.notifications.push(context.value)
    } else {
      state.contactForm.notifications = state.contactForm.notifications.filter((n) => n !== context.value)
    }
  },
  setNotifications (state, notifications) {
    state.notifications = notifications
  },
  resetPartnerContactForm (state) {
    state.contactForm = state.defaultContactForm
  },
  resetTaxForm (state) {
    state.taxForm = state.defaultTaxForm
  },
  addPartnerContact (state, contact) {
    let isExist = state.form.contacts.filter(current => current.id === contact.id).length
    if (!isExist) {
      state.form.contacts.push(contact.contact)
    }
  },
  removePartnerContact (state, id) {
    state.form.contacts = state.form.contacts.filter((c) => c.id !== id)
  },
  addPartnerTax (state) {
    state.taxs.push(state.taxForm)
    state.taxForm = {
      country: null,
      tax_id: null
    }
  },
  deletePartnerTax (state, index) {
    state.taxs.splice(index, 1)
    state.newtaxs.splice(index, 1)
  },
  resetPartnerOrgStory (state, storyMedia) {
    state.form.user_partner.org_story = storyMedia
  }
}

const getters = {
  getPartnerForm (state) {
    return state.form
  },
  getPartnerUser (state) {
    return state.user
  },
  getPartnerPercentProfileComplete (state) {
    if (state.form.user_partner) return userHelper.userPartnerProfileComplete(state.form.user_partner)
  },
  getPartnerContactForm (state) {
    return state.contactForm
  },
  getPartnerTaxs (state) {
    return state.taxs
  },
  getPartnerNewTaxs (state) {
    return state.newtaxs
  },
  getPartnerPasswordForm (state) {
    return state.passwordForm
  },
  getNotifications (state) {
    return state.notifications
  },
  getPartnerTaxForm (state) {
    return state.taxForm
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/partner/profile/form.js